export default "__VITE_ASSET__CzltBUwu__"